import { SVGProps } from 'react';

const TentTree = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m20 5-3-3-3 3m3-3v12m-3-4 3-3 3 3m-3 4H7l-5 8h20zm-9 0v8m1-8 5 8M6 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
  </svg>
);
export default TentTree;
